const updateBorder = function () {
  const items = $('.scrollmenu__items');
  const width = $(items.children()[0]).outerWidth();
  const elementIndex =
    Math.round((items.width() + items.scrollLeft()) / width) - 1;
  items.children().each(function (index) {
    if (index !== elementIndex) {
      $(this).css('border-right', '1px dotted #5d6e6f');
    } else {
      $(this).css('border-right', 'none');
    }
  });
};

$(function () {
  updateBorder();

  $('.scrollmenu__back').on('click', function () {
    const items = $('.scrollmenu__items');
    const itemsCount = items.children().length;
    const scrollWidth = items.prop('scrollWidth');
    const scrollLeft = Math.floor(scrollWidth / itemsCount) + 1;
    items.children().each(function (i) {
      if (i < items.children().length - 1) {
        $(this).css('border-right', '1px dotted #5d6e6f');
      }
    });
    $(items).animate(
      {scrollLeft: `-=${scrollLeft}px`},
      500,
      'linear',
      function () {
        updateBorder();
      }
    );
  });

  $('.scrollmenu__next').on('click', function () {
    const items = $('.scrollmenu__items');
    const itemsCount = items.children().length;
    const scrollWidth = items.prop('scrollWidth');
    const scrollLeft = Math.floor(scrollWidth / itemsCount) + 1;
    items.children().each(function (i) {
      if (i < items.children().length - 1) {
        $(this).css('border-right', '1px dotted #5d6e6f');
      }
    });
    $(items).animate(
      {scrollLeft: `+=${scrollLeft}px`},
      500,
      'linear',
      function () {
        updateBorder();
      }
    );
  });

  $('.navbar-toggler').on('click', function () {
    if ($('#search').hasClass('show')) {
      $('#portal-globalnav-wrapper .search-toggler').trigger('click');
    }
  });

  $('.search-toggler').on('click', function () {
    if ($('#navbarNav').hasClass('show')) {
      $('#portal-globalnav-wrapper .navbar-toggler').trigger('click');
    }
  });

  const navWidth = 256 * 3;
  const documentWidht = $(document).width();
  $('#portal-globalnav').children().each(function () {
    if ($(this).position().left + navWidth > documentWidht) {
      $(this).addClass('open-left');
    }
  });

  $("a[rel^='prettyPhoto'], a.lightbox, a.prettyPhoto").prettyPhoto({social_tools: null});

  $("a[href='#topper']").on('click', function () {
    $("html, body").animate({ scrollTop: 0 }, "fast");
    return false;
  });

});
